import type {
  BusinessDirectoryFiltersState,
  BusinessDirectorySort,
  CommunityBusiness,
} from '@/types';

export function buildBusinessDirectoryParams(
  search: string,
  filters: BusinessDirectoryFiltersState,
  page?: number,
  limit = 50,
  sort?: BusinessDirectorySort
): URLSearchParams {
  const params = new URLSearchParams();
  if (page != null) {
    params.set('page', String(page));
    params.set('limit', String(limit));
  }
  if (search.trim()) params.set('q', search.trim());
  if (filters.category) params.set('category', filters.category);
  if (filters.city) params.set('city', filters.city);
  if (filters.state) params.set('state', filters.state);
  if (filters.country) params.set('country', filters.country);
  if (sort && sort !== 'business') params.set('sort', sort);
  return params;
}

export function hasActiveDirectoryFilters(filters: BusinessDirectoryFiltersState): boolean {
  return Boolean(filters.category || filters.city || filters.state || filters.country);
}

export function countActiveDirectoryFilters(filters: BusinessDirectoryFiltersState): number {
  return [filters.category, filters.city, filters.state, filters.country].filter(Boolean).length;
}

export function sortBusinessDirectoryEntries(
  businesses: CommunityBusiness[],
  sort: BusinessDirectorySort
): CommunityBusiness[] {
  return [...businesses].sort((a, b) => {
    const left = (sort === 'name' ? a.owner.name : a.name).trim();
    const right = (sort === 'name' ? b.owner.name : b.name).trim();
    const byField = left.localeCompare(right, undefined, { sensitivity: 'base' });
    if (byField !== 0) return byField;
    const byBusiness = a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    if (byBusiness !== 0) return byBusiness;
    return a.id.localeCompare(b.id);
  });
}
